import { Box, VStack } from "@chakra-ui/react";
import { parse } from "date-fns";
import { useMemo } from "react";
import { useDashboardForm } from "../../types/dashboardForm";
import { ProjectID, projectToTitle } from "../../types/project";
import { DashboardForm } from "../Form/DashboardForm/DashboardForm";
import { FormBgContainer } from "../FormBgContainer/FormBgContainer";
import { GenericDashboard } from "../GenericDashboard/GenericDashboard";
import { TabHeading } from "../TabHeading/TabHeading";

export function GenericDashboardView({ project }: { project: ProjectID }) {
  const formik = useDashboardForm(project);
  const { startDate, endDate, sites, analyte } = formik.values;
  const title = useMemo(() => `${projectToTitle(project)} ${analyte !== null && `(${analyte})`} `, [project, analyte]);

  return (
    <VStack alignItems={"stretch"}>
      <FormBgContainer>
        <VStack alignItems={"stretch"} flex="1">
          <TabHeading text={title} />
          <DashboardForm formik={formik} project={project} />
        </VStack>
      </FormBgContainer>

      {sites.length > 0 && analyte != null && startDate && endDate && (
        <Box padding={16} paddingTop={0}>
          <GenericDashboard
            sites={sites}
            analyte={analyte}
            startDate={parse(startDate, "yyyy-MM-dd", new Date())}
            endDate={parse(endDate, "yyyy-MM-dd", new Date())}
            project={project}
          />
        </Box>
      )}
    </VStack>
  );
}
